<template>
  <v-container fluid class="cont-pagina">
    <v-row class="no-gutters">
      <v-col cols="12">
        <h3 class="titulo-contendor text-center py-3">Buscar elementos</h3>
      </v-col>
    </v-row>
    <v-row class="no-gutters">
      <v-card style="width: 100%;">
        <v-card-text>
          <selector
            :key="nKeyCleanCampos+'sSede'"
            :ref="`form-sede`"
            v-model="nSede"
            :sLabel="'SEDE'"
            :bObligatorio="true"
            :sCondicion="'==nIDSedeBase'"
            :sCampoItem="'Nombre'"
            :bEditable="false"
            :sModoCampo="'2'"
            :sIdItem="'idsede'"
            :sTabla="'sede'"
          />
          <texto
            class="mt-5"
            :key="nKeyCleanCampos+'sBusqueda'"
            :oAtributos="{
              prependInnerIcon: 'mdi-magnify'
            }"
            :ref="`form-buscador`"
            :sModoCampo="'2'"
            v-model="sBuscador"
            :sLabel="'BUSCAR POR PALABRA CLAVE'"
          />
          <v-row>
            <v-col cols="12" class=" mt-4 pb-0"><span class="segundoEstiloTitulo">FECHA DE REGISTRO</span> <span class="red--text">*</span></v-col>
            <v-col cols="6">
              <v-menu
                ref="bMenuFechaInicial"
                v-model="bMenuFechaInicial"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="sFechaInicial"
                    label="Desde"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="sFechaInicial"
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                ref="bMenuFechaFinal"
                v-model="bMenuFechaFinal"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                left
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="sFechaFinal"
                    label="Hasta"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="sFechaFinal"
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class=" mt-4 pb-0"><span class="segundoEstiloTitulo">HORA DE REGISTRO</span></v-col>
            <v-col cols="6">
              <v-menu
                ref="menuHoraInicial"
                v-model="bMenuHoraInicial"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="sHoraInicial"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="sHoraInicial"
                    label="Desde"
                    prepend-inner-icon="mdi-clock-time-four-outline"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="bMenuHoraInicial"
                  format="24hr"
                  v-model="sHoraInicial"
                  full-width
                  @click:minute="$refs.menuHoraInicial.save(sHoraInicial)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                ref="menuHoraFinal"
                v-model="bMenuHoraFinal"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="sHoraFinal"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="sHoraFinal"
                    label="Hasta"
                    prepend-inner-icon="mdi-clock-time-four-outline"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="bMenuHoraFinal"
                  v-model="sHoraFinal"
                  format="24hr"
                  full-width
                  @click:minute="$refs.menuHoraFinal.save(sHoraFinal)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <div class="mt-5">
            <v-btn
              :disabled="onValidarBtnBuscar"
              block
              color="primary"
              @click="onConsultarElementos"
              elevation="2"
            ><v-icon class="mr-2">mdi-magnify</v-icon>Buscar elementos</v-btn>
            <v-btn
              block
              class="mt-4"
              elevation="2"
              @click="onLimpiarConsulta"
            >Limpiar Busqueda</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row v-if="bBuscado">
      <v-col cols="8" class="segundoEstiloTitulo">RESULTADOS DE BÚSQUEDA</v-col>
      <v-col cols="4" class="text-right">{{ aListadoElementos?.length }} resultado(s)</v-col>
    </v-row>
    <v-row class="mt-4" v-if="bBuscado" style="max-width: 380px !important;">
      <cardElemento :aElementos="aListadoElementos"/>
    </v-row>
  </v-container>
</template>
<script>
import mxFuncionesBasicas from "@/mixins/FuncionesBasicas.js";
import axiosServices from "@/services/axiosServices.js";
// import { mapGetters } from 'vuex';
import selector from '@/components/Form/Componentes/FormSelect.vue';
import texto from '@/components/Form/Componentes/FormTexto.vue';
import cardElemento from '@/components/elementosExtraviados/cardElementoExtraviado.vue';
import APPutils from '@/utils/APPutils.js';

export default {
  name: 'busquedaElemento',
  mixins: [mxFuncionesBasicas],
  components:{
    selector,
    texto,
    axiosServices,
    cardElemento
  },
  data() {
    return {
      nKeyCleanCampos:0,
      nSede:null,
      sBuscador:"",
      sFechaInicial:"",
      sFechaFinal:"",
      sHoraInicial:"",
      sHoraFinal:"",
      bMenuFechaInicial:false,
      bMenuFechaFinal:false,
      bMenuHoraFinal:false,
      bMenuHoraInicial:false,
      aListadoElementos:[],
      bBuscado:false
    }
  },
  methods: {
    async onConsultarElementos(){
      let oResult = await axiosServices.postConfiguration("/elementosExtraviados/obtenerElementoBusqueda", {
        sFechaInicial:this.sFechaInicial,
        sFechaFinal:this.sFechaFinal,
        sHoraInicial:this.sHoraInicial,
        sHoraFinal:this.sHoraFinal,
        sBuscador:this.sBuscador,
        nSede:this.nSede
      },true);

      if(oResult?.nStatusCode==200){
        this.aListadoElementos = oResult.aData;
        this.bBuscado = true;
      }
      
    },
    onLimpiarConsulta(){
      this.aListadoElementos = []
      this.bBuscado = false;
      this.sBuscador = "";
      this.sFechaInicial = "";
      this.sFechaFinal = "";
      this.sHoraInicial = "";
      this.sHoraFinal = "";
    }
  },
  mounted() {
    this.nSede = APPutils.onGetIdSede().toString();
  },
  computed: {
    onValidarBtnBuscar () {
      if(this.sFechaFinal!=""&&this.sFechaInicial!=""){ return false; } return true;
    }
  }

}
</script>
<style lang="scss">
tbody{
  tr{
    td{
      font-size: 11px!important;
      min-height: 30px!important;
    }
  }
}
.v-icon.v-icon{
  font-size: 18px;
}
.cont-item-pag{
  transform: scale(0.8);
}
.text-registros{
  font-size:12px;
  text-align: left;
}
.segundoEstiloTitulo{
  color: #0056D3;
  font-size: medium;
}
</style>